module.exports = __webpack_public_path__ + "img/title-access.17788c4d.svg";